<template>
  <section class ="custom-base-info-container">
    <base-form
      ref="form"
      v-bind="form"
      :options="{
        columnOptions,
        contentModelOptions
      }"
    >
      <template #login="scope">
        <el-form-item class="login-wrap" style="margin-bottim: 0" prop="login">
          <div class="login-item">
            <el-checkbox v-model="scope.form.login">需要登录</el-checkbox>
          </div>
        </el-form-item>
      </template>
    </base-form>
  </section>
</template>
<script>
import baseForm from '@/components/mixins/baseForm'
import {
  mapGetters,
  mapActions
} from 'vuex'

export default {
  name: 'CustomBaseInfoContainer',
  mixins: [baseForm],
  data () {
    return {
      form: {
        labelWidth: '154px',
        form: {
          id: '',
          name: '',
          dataPosition: 1,
          channelId: '',
          modelId: '',
          address: '',
          login: false
        },
        formItems: [
          {
            prop: 'name',
            label: '任务名称',
            maxlength: 50
          },
          {
            prop: 'dataPosition',
            label: '数据存储位置',
            type: 'radio',
            options: [
              {
                label: '采集内容库',
                value: 1
              },
              {
                label: '栏目',
                value: 2
              }
            ]
          },
          {
            prop: 'channelId',
            label: '',
            labelWidth: '154px',
            hiddenKey: 'dataPosition',
            hiddenValue: 2,
            type: 'selectTree',
            options: 'columnOptions'
          },
          {
            prop: 'modelId',
            label: '选择内容模型',
            type: 'select',
            options: 'contentModelOptions',
            popoverText: '若所选的内容模型中不包含所选字段，则不保存该字段'
          },
          {
            prop: 'address',
            label: '输入要采集的网址',
            type: 'textarea',
            placeholder: 'https://...... (可输入多条，并用换行隔开）'
          },
          {
            props: 'login',
            label: '',
            labelWidth: '154px',
            type: 'slot'
          }
        ],
        rules: {
          name: [
            this.$rules.required()
          ],
          dataPosition: [
            this.$rules.required()
          ],
          modelId: [
            this.$rules.required()
          ],
          address: [
            this.$rules.required()
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters(['columnOptions', 'contentModelOptions'])
  },
  methods: {
    ...mapActions('column', ['FetchColumnOptions']),
    ...mapActions('content', ['FetchContentModeList'])
  },
  mounted () {
    this.FetchColumnOptions()
    this.FetchContentModeList()
  }
}
</script>
<style lang="scss">

</style>
